module.exports = __webpack_public_path__ + "img/5_29.7d660b6a.png";